import {
  AHIcon,
  AHSeparator,
  AHTeamIconCircle,
  AHTeamIconType,
  Box,
  ListItem,
  Space,
  useLayoutContext,
} from "arkh";
import React, { useCallback } from "react";
import { KPIFillMode, KPIUnit } from "../Edit/KPIEditParamList";
import { KPITeamGroup } from "../Edit/KPITeamGroup";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { SectionContainer } from "../Create/SectionContainer";
import { KPITeamGroupListItem } from "./KPITeamGroupListItem";
import { KPIFrequenceListItem } from "../Edit/KPIFrequencyListItem";
import { useIntl } from "react-intl";

type KPIPropertiesComponentProps = {
  teamGroup: KPITeamGroup[];
  team: {
    id: string;
    name: string;
    color: string | null;
    icon: string | null;
  };
  goalDirection: "greater" | "less";
  hasGoal: boolean;
  title: string;
  fillMode: KPIFillMode;
  spaceHorizontal?: Space;
  byweekday: number[];
  unit: KPIUnit;
  onChangeUnit?(): void;
  onChangeTitle?(): void;
  onChangeAdminTeam?(): void;
  onChangeFrequency?(): void;
  onChangeSections?(): void;
};

export function KPIPropertiesComponent(props: KPIPropertiesComponentProps) {
  const intl_tokens = useIntlTokens();
  const intl = useIntl();
  const renderItem = useCallback(
    (teamGroup: KPITeamGroup, index: number) => (
      <React.Fragment key={teamGroup.teamId}>
        {index > 0 ? <AHSeparator /> : null}
        <KPITeamGroupListItem
          teamGroup={teamGroup}
          goalDirection={props.goalDirection}
          hasGoal={props.hasGoal}
        />
      </React.Fragment>
    ),
    [props.goalDirection, props.hasGoal]
  );
  const layout = useLayoutContext();

  return (
    <>
      <SectionContainer title={intl_tokens.Name} onPress={props.onChangeTitle}>
        <ListItem isFirst isLast border="border-primary">
          <ListItem.Title>{props.title}</ListItem.Title>
        </ListItem>
      </SectionContainer>
      <SectionContainer
        title={intl.formatMessage({
          defaultMessage: "When do you want this KPI entered",
          description: "KPIPropertiesComponent: frequency seciton title",
        })}
        onPress={props.onChangeFrequency}
      >
        <KPIFrequenceListItem
          byweekday={props.byweekday}
          fillMode={props.fillMode}
        />
      </SectionContainer>
      <SectionContainer
        title={intl.formatMessage({
          defaultMessage: "Managing team",
          description: "KPI properties component managing team section title",
        })}
        onPress={props.onChangeAdminTeam}
      >
        <ListItem
          border="border-primary"
          left={
            <AHTeamIconCircle
              type={props.team.icon as AHTeamIconType}
              color={props.team.color}
              size="smallMedium"
            />
          }
          isFirst
          isLast
        >
          <ListItem.Title>{props.team.name}</ListItem.Title>
        </ListItem>
      </SectionContainer>
      <SectionContainer title={intl_tokens.Unit} onPress={props.onChangeUnit}>
        <ListItem
          border="border-primary"
          left={
            <Box
              style={{
                width: layout.circle.smallMedium,
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              {props.unit === "CURRENCY" ? (
                <AHIcon type="currency" />
              ) : (
                <AHIcon type="other" />
              )}
            </Box>
          }
          isFirst
          isLast
        >
          <ListItem.Title>
            {props.unit === "CURRENCY"
              ? intl_tokens.Currency
              : intl_tokens.Other}
          </ListItem.Title>
        </ListItem>
      </SectionContainer>
      <SectionContainer
        title={intl_tokens.MeasurementAreas}
        onPress={props.onChangeSections}
      >
        <Box
          style={{ overflow: "hidden", borderWidth: 1 }}
          cornerRadius="large"
          borderColor="border-primary"
        >
          {props.teamGroup.map(renderItem)}
        </Box>
      </SectionContainer>
    </>
  );
}
